import { useCTSignIn } from '@riddler-co-jp/specc-auth-client';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes, useMatch } from 'react-router-dom';

import { useStartTimesEffect } from '../../api/stages';
import { appActions } from '../../redux/actions/appActions';
import { app } from '../..';
import Loading from './common/Loading';
import Stage1 from './stagePages/stage1/Stage1';

interface EventRouterProps {}

export const EventsRouter: React.FC<EventRouterProps> = () => {
  const match = useMatch('/events/:eventId/*');
  useStartTimesEffect();
  const dispatch = useDispatch();

  const [signedIn, signInLoading] = useCTSignIn(
    app,
    'switch',
    match?.params.eventId,
    '1',
    match?.pathname === match?.pathnameBase ||
      match?.pathname === `${match?.pathnameBase}/`
  );

  React.useEffect(() => {
    if (signInLoading) {
      dispatch(appActions.setLoadingState({ visible: true }));
    } else {
      dispatch(appActions.setLoadingState({ visible: false }));
    }
  }, [dispatch, signInLoading]);

  if (signInLoading) {
    return <Loading />;
  }
  if (!signInLoading && !signedIn) {
    return <Navigate to='/auth-error' />;
  }

  return (
    <Routes>
      <Route path='/:eventId' element={<Stage1 />} />
      <Route path='/:eventId/*' element={<Stage1 />} />
    </Routes>
  );
};

export default EventsRouter;
